<script lang="ts">
  import { skills } from './data';
</script>

<section class="mt-2 md:mt-0 print:mt-0 print:mb-2">
  <h2 class="text-2xl uppercase print:text-lg print:mb-1">Skills</h2>
  <hr />
  <ul>
    {#each skills as skill}
      <li class="mb-3 md:mb-0 print:mb-1">
        <span class="text-base font-bold print:text-sm"
          >{skill.category.concat(': ')}</span
        ><span class="text-sm md:text-base print:text-sm">{skill.content}</span>
      </li>
    {/each}
  </ul>
</section>
